const PrivacyPolicyBody = () => {
  return (
    <section className="page privacy-policy section-spacing-20">
      <div className="container">
        <div className="large">
          <div className="section-content-container section-spacing-100 no-padding-top width-600 margin-auto">
            <ul className="page-sections-container">
              <li className="page-section-item">
                <h2 className="page-section-title">Introduction</h2>
                <p>
                  The FLEXIBLE PAINTERS WORLD AND SERVICES LTD, ("us", "we", or
                  "our") operate http://www.flexipainters.com (the "Site"). This
                  page informs you of our policies regarding the collection, use
                  and disclosure of Personal Information we receive from users
                  of the Site.
                </p>
                <p>
                  By using the Site, you agree to the collection and use of
                  information in accordance with this policy.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">
                  Information Collection & Use
                </h2>
                <p>
                  While using our Site, we may ask you to provide us with
                  certain personally identifiable information that can be used
                  to contact or identify you. Personally identifiable
                  information may include, but is not limited to your name and
                  email address or phone number ("Personal Information").
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Log Data</h2>
                <p>
                  Like many site operators, we collect information that your
                  browser sends whenever you visit our Site ("Log Data").
                </p>
                <p>
                  This Log Data may include information such as your computer's
                  Internet Protocol ("IP") address, browser type, browser
                  version, the pages of our Site that you visit, the time and
                  date of your visit, the time spent on those pages and other
                  statistics.
                </p>
                <p>
                  In addition, we may use third party services such as Google
                  Analytics that collect, monitor and analyze this information.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Communication</h2>
                <p>
                  We may use your Personal Information to contact you with
                  newsletters, updates on our works, campaigns and other
                  information.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Cookies</h2>
                <p>
                  Cookies are files with small amount of data, which may include
                  an anonymous unique identifier. Cookies are sent to your
                  browser from a web site and stored on your computer's hard
                  drive.
                </p>
                <p>
                  Like many sites, we use "cookies" to collect information. You
                  can instruct your browser to refuse all cookies or to indicate
                  when a cookie is being sent. However, if you do not accept
                  cookies, you may not be able to use some portions of our Site.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Security</h2>
                <p>
                  The security of your Personal Information is important to us,
                  but remember that no method of transmission over the Internet,
                  or method of electronic storage, is 100% secure.
                </p>
                <p>
                  While we strive to use commercially acceptable means to
                  protect your Personal Information, we cannot guarantee its
                  absolute security.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">
                  Changes to this Privacy Policy
                </h2>
                <p>
                  This Privacy Policy is effective as of 10th June 2026 and will
                  remain in effect except with respect to any changes in its
                  provisions in the future, which will be in effect immediately
                  after being posted on this page.
                </p>
                <p>
                  We reserve the right to update or change our Privacy Policy at
                  any time and you should check this Privacy Policy
                  periodically. Your continued use of the Site after we post any
                  modifications to the Privacy Policy on this page will
                  constitute your acknowledgment of the modifications and your
                  consent to abide and be bound by the modified Privacy Policy.
                </p>
                <p>
                  If we make any material changes to this Privacy Policy, we
                  will notify you either through the email address you have
                  provided us, or by placing an indication on our website or a
                  prominent notice our social media platforms.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">
                  Your rights on your personal data
                </h2>
                <p>
                  You have the following rights in respect to your personal
                  data;
                </p>
                <ul>
                  <li>
                    <span>
                      The right to request for a copy of your personal data
                      which flexipainters.com holds about you,
                    </span>
                  </li>
                  <li>
                    <span>
                      The right to request that your personal data is deleted
                      where it is no longer necessary for flexipainters.com to
                      retain such data,
                    </span>
                  </li>
                  <li>
                    <span>The right to lodge complaints.</span>
                  </li>
                </ul>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Complaints Procedure</h2>
                <p>
                  A complaint is any expression of dissatisfaction, whether
                  justified or not about any aspect of flexipainters.com.
                </p>
                <p>
                  To exercise all relevant rights, queries or complaints, please
                  in first instance, contact us via our email
                  info@flexipainters.com or give us a call on +256 775 866 449.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">
                  How long shall we take to respond when you write to us?
                </h2>
                <p>
                  We will get a detailed response to you within 2 weeks. The aim
                  is to investigate each complaint thoroughly and give a reply
                  stating out how the problem will be dealt with. If it's to
                  take longer than this, we will acknowledge that we receive
                  your complaints and how long you can wait.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">What shall we do?</h2>
                <p>Our complaints policy will be emailed to you on request.</p>
                <p>
                  We will do our best to address your concerns. Please, when you
                  write to us, feel free to offer your suggestions on how you
                  think it should be resolved.{" "}
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">
                  If you're still not satisfied?
                </h2>
                <p>
                  We will advise you on options if you want to take it to the
                  next stage.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">What we will not do?</h2>
                <p>
                  We won't engage in lengthy discussions on complaints which are
                  not directly related to our work!
                </p>
                <p>
                  We can't reply to complaints that are illegible, abusive,
                  prejudiced. And where a complaint is made anonymous, we can't
                  reply to it but we investigate to see what lessons can be
                  learned.{" "}
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Our Pledge</h2>
                <p>
                  We will take all complaints seriously and see them as an
                  opportunity to learn and improve on the way we operate. We
                  will be open to acknowledge our mistake and prevent it from
                  happening again.
                </p>
                <p>
                  And our prayer is that we should never give you reasons to
                  complain.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title">Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please
                  contact us:
                </p>
                <p>
                  <span className="italic">Phone Number: </span>{" "}
                  <a href="tel:+256702096666">+256 (0) 775 866 449</a>
                </p>
                <p className="padding-bottom-8">
                  <span className="italic">Email Address: </span>{" "}
                  <a href="mailto:info@flexipainters.com">
                    info@flexipainters.com
                  </a>
                </p>
                <p className="italic">
                  Last Updated: 10th June 2026
                </p>
                <p className="section-spacing-40 no-padding-bottom border-blue-top center">
                  Kind Regards,
                </p>
                <p className="center">www.FLEXIPAINTERS.com</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyBody;
